module.exports = __webpack_public_path__ + "static/bg-last-person-95dbcb03f23dde7e76b667be6eaaaaf5.jpg";